import { Link } from "react-router";
import { formatSek, REFERENCE_DESIGNS } from "./referenceDesignsData";
import "./referenceDesign.css";

interface ReferenceDesignCardsProps {
	title: string;
	intro: string;
	excludePath?: string;
}

export function ReferenceDesignCards({
	title,
	intro,
	excludePath,
}: ReferenceDesignCardsProps) {
	const designs = REFERENCE_DESIGNS.filter(
		(design) => design.path !== excludePath,
	);

	return (
		<section
			className="reference-design-cluster"
			aria-labelledby="reference-designs-heading"
		>
			<div className="reference-design-cluster-heading">
				<p className="reference-kicker">Digitala referensritningar</p>
				<h2 id="reference-designs-heading">{title}</h2>
				<p>{intro}</p>
			</div>
			<div className="reference-design-grid">
				{designs.map((design) => (
					<article className="reference-design-card" key={design.path}>
						<span>{design.badge}</span>
						<h3>{design.headline}</h3>
						<p>{design.blurb}</p>
						<dl>
							<div>
								<dt>Storlek</dt>
								<dd>{design.areaLabel}</dd>
							</div>
							<div>
								<dt>Värme</dt>
								<dd>{design.heater === "wood" ? "Ved" : "El"}</dd>
							</div>
							<div>
								<dt>DIY-budget</dt>
								<dd>{formatSek(design.diyBudgetSek)}</dd>
							</div>
						</dl>
						<Link to={design.path}>Se ritning och kalkyl</Link>
					</article>
				))}
			</div>
		</section>
	);
}
